import { create } from 'zustand';

// Persist theme in localStorage — safe: value is not sensitive.
const THEME_KEY = 'sp_theme';

function getInitialTheme() {
  if (typeof window === 'undefined') return 'light';
  try {
    const stored = window.localStorage.getItem(THEME_KEY);
    if (stored === 'light' || stored === 'dark') return stored;
  } catch {
    /* ignore */
  }
  if (
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-color-scheme: dark)').matches
  ) {
    return 'dark';
  }
  return 'light';
}

export const useUiStore = create((set, get) => ({
  // Theme --------------------------------------------------------------
  theme: getInitialTheme(),
  setTheme: (theme) => {
    try {
      window.localStorage.setItem(THEME_KEY, theme);
    } catch {
      /* ignore */
    }
    set({ theme });
  },
  toggleTheme: () => {
    const next = get().theme === 'dark' ? 'light' : 'dark';
    get().setTheme(next);
  },

  // Sidebar ------------------------------------------------------------
  sidebarOpen: false,
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),

  // Global loading ------------------------------------------------------
  globalLoading: false,
  setGlobalLoading: (v) => set({ globalLoading: v }),

  // Modal stack ---------------------------------------------------------
  modal: null,
  openModal: (payload) => set({ modal: payload }),
  closeModal: () => set({ modal: null }),

  // Toast notifications ------------------------------------------------
  toasts: [],
  pushToast: ({ type = 'info', title = '', message = '', duration = 4000 }) => {
    const id = `t_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
    set((s) => ({ toasts: [...s.toasts, { id, type, title, message, duration }] }));
    if (duration > 0) {
      setTimeout(() => {
        set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
      }, duration);
    }
    return id;
  },
  dismissToast: (id) =>
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));
